import classNames from 'classnames';
import { HTMLAttributes, ReactNode, useContext } from 'react';

import { trackServiceDetailsModalOpen } from '@/loader/trackServiceDetailsModalOpen';

import AuthContext from '@/contexts/Auth/AuthContext';

import { Button, ButtonVariant, Typography, Icon, Image, Informer, InformerProps, ExternalImgPath } from '../';

import './ServiceCardStyles.scss';

export interface ServiceCardProps extends HTMLAttributes<HTMLDivElement> {
  icon: ExternalImgPath;
  title: string;
  subTitle?: string;
  informer?: InformerProps;
  onDetailsClick?: () => void;
  buttonLink?: ReactNode;
}

export const ServiceCard: React.FC<ServiceCardProps> = ({
  title,
  subTitle,
  icon,
  buttonLink,
  informer,
  onDetailsClick,
  className,
  ...restProps
}) => {
  const { storedLinks } = useContext(AuthContext);

  const serviceIcon = (storedLinks?.app?._baseUrl + icon) as ExternalImgPath;

  return (
    <article {...restProps} className={classNames('service-card', className)}>
      <div className="service-card__content">
        <Image src={serviceIcon} width={48} height={48} alt={title} fallback="/images/icons-set.svg" />
        <Typography variant="H4" className="service-card__title">
          {title}
        </Typography>
        {subTitle && <Typography className="service-card__subtitle">{subTitle}</Typography>}
      </div>
      <div className="service-card__footer">
        {onDetailsClick && (
          <Button
            onClick={(): void => {
              onDetailsClick();
              trackServiceDetailsModalOpen(title);
            }}
            variant={ButtonVariant.GHOST}
            className="service-card__details"
          >
            <Icon name="attention" color="blue" />
            Детальніше
          </Button>
        )}
        {informer && <Informer {...informer} />}
        {buttonLink && buttonLink}
      </div>
    </article>
  );
};
